export const APPLICATION_ROUTES = {
  HOME: '/',
  TRACKER: '/tracker',
  TRACKER_MAP_AREA: '/tracker/mapArea',
};
